import React from 'react';
import Footer from './components/Footer';
import NavBar from './components/NavBar';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Pitch from './components/Pitch';
import MyServices from './components/MyServices';

const App = () => {
 
  return (
    <div className="App">
      <div className="intro">
        <NavBar />
        <Home />
      </div>
      <Pitch />
      <Projects />
      <MyServices />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
